export function getApiErrorMessage(error) {
  const message = error?.message || String(error)
  const fromIndex = message.lastIndexOf(' from ')
  return fromIndex > 0 ? message.substring(0, fromIndex) : message
}

export function showTestSmsResultToast(addToast, response, destination, successMessage) {
  const warningMessage = response?.warningMessage
  if (warningMessage) {
    addToast(warningMessage, {
      appearance: 'warning',
      autoDismiss: false
    })
    return
  }

  addToast(successMessage || `We've sent a test message to ${destination}`, {
    appearance: 'success',
    autoDismiss: true
  })
}

export function showTestSmsErrorToast(addToast, error, fallbackMessage) {
  const message = getApiErrorMessage(error)
  addToast(message || fallbackMessage, {
    appearance: 'error',
    autoDismiss: true
  })
}

export function getModifyBooleans(details) {
  // Business logic
  const modifyBooleans = {
    isModifyMainTemplate: false,
    isModifyMainPromo: false,
    isModifyOptInTemplate: false,
    isModifyOptInPromo: false,
    isModifyOptOutTemplate: false
  }

  const mainTemplateVars = [
    'messageTemplate',
    'customDeliveryStatus',
    'deliveryFinishDate',
    'deliveryStartDate',
    'isActive',
    'messageMediaUrls',
    'customUrl'
  ]

  const mainPromoVars = [
    'maxDiscountPercentage',
    'minNightsToStay',
    'promotionCode',
    'promotionTagline'
  ]

  const optinTemplateVars = [
    'optInAcceptResponseTemplate',
    'optInMediaUrls',
    'optInTemplate'
  ]

  const optinPromoVars = [
    'optInMinNightsToStay',
    'optInPromotionCode',
    'optInMaxDiscountPercentage'
  ]

  const optoutTemplateVars = ['optOutTemplate']

  if (Object.keys(details).some(r => mainTemplateVars.includes(r))) {
    modifyBooleans.isModifyMainTemplate = true
  }

  if (Object.keys(details).some(r => mainPromoVars.includes(r))) {
    modifyBooleans.isModifyMainPromo = true
  }

  if (Object.keys(details).some(r => optinTemplateVars.includes(r))) {
    modifyBooleans.isModifyOptInTemplate = true
  }

  if (Object.keys(details).some(r => optinPromoVars.includes(r))) {
    modifyBooleans.isModifyOptInPromo = true
  }

  if (Object.keys(details).some(r => optoutTemplateVars.includes(r))) {
    modifyBooleans.isModifyOptOutTemplate = true
  }

  return modifyBooleans
}
